import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getPaymodeList = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllPaymode}?CompanyCode=${companyCode}`
  );
  return data;
};

const getPaymodeById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllPaymode}?isAll=false&code=${code}`
  );
  return data;
};

const insertPaymode = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertPaymode, input);
  return data;
};

const updatePaymode = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdatePaymode, input);
  return data;
};

const deletePaymode = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.DeletePaymode, input);
  return data;
};

export const useGetPaymodeQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllPaymode],
    queryFn: () => getPaymodeList(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useGetPaymodeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllPaymode],
    queryFn: () => getPaymodeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertPaymodeMutation = () => {
  return useMutation({
    mutationFn: insertPaymode,
  });
};

export const useUpdatePaymodeMutation = () => {
  return useMutation({
    mutationFn: updatePaymode,
  });
};

export const useDeletePaymodeMutation = () => {
  return useMutation({
    mutationFn: deletePaymode,
  });
};
